import axios, { AxiosRequestHeaders } from 'axios';

const baseUrl = '/api/episerver/v3.0/content/';

export const createContentDeliveryClient = ( config?: { headers: AxiosRequestHeaders }  ) => {
  return axios.create({
    headers: {
      'Accept-Language': 'en',
      ...config?.headers,
    },
    baseURL: baseUrl,
    ...config
  })
}